/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datagrid_Filteredcolumntag3Inputs */

const en_datagrid_filteredcolumntag3 = /** @type {(inputs: Datagrid_Filteredcolumntag3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`filtered`)
};

/**
* | output |
* | --- |
* | "filtered" |
*
* @param {Datagrid_Filteredcolumntag3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const datagrid_filteredcolumntag3 = /** @type {((inputs?: Datagrid_Filteredcolumntag3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datagrid_Filteredcolumntag3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_datagrid_filteredcolumntag3(inputs)
});
export { datagrid_filteredcolumntag3 as "dataGrid_filteredColumnTag" }